import React from 'react';

import {
  object, number, string
} from 'yup';

import FormResource from './FormResource.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FieldArrayIterables from '~/commons/components/FieldArrayIterables.jsx';

const defaults = {
  address: '',
  seller: '',
  buyer: '',
  mint: '',
  horse: '',
  price: 0,
  currency: '',
  status: '',
  transactions: [],
};

const FormTrade = ({
  trade,
}) => (
  <FormResource
    {...{
      defaults,
      schema: object({
        price: number().min(0),
      }),
      stored: trade,
      api: '/api/site/trades',
      options: {omitIds: false},
    }}
  >
    <div className="form-row">
      <div className="col">
      <FormGroup name="status" label="Status" disabled/>
      </div>
      <div className="col">
      <FormGroup name="address" label="Address" disabled/>
      </div>
      <div className="col">
      <FormGroup name="mint" disabled/>  
      </div>
    </div>

    <div className="form-row">
      <div className="col">
      <FormGroup name="horse.name" label="Horse Name" disabled/>
      </div>
      <div className="col">
      <FormGroup name="horse.clsLv" label="Horse Class" disabled/>  
      </div>
    </div>

    <div className="form-row">
      <div className="col">
      <FormGroup name="seller" disabled/>
      </div>
      <div className="col">
      <FormGroup name="buyer" disabled/>
      </div>
    </div>

    <div className="form-row">
      <div className="col">
      <FormGroup name="price" label="Price" disabled/>  
      </div>
      <div className="col">
      <FormGroup name="currency" label="Currency" disabled/>
      </div>
    </div>

    <div className="form-group">
      <label>Transactions</label>
      <div className="border p-3">
      <FieldArrayIterables name="transactions">
        {(s, i, helpers) => (
          <div className="row">
            <div className="col-auto" key={i}>
              <div className="text-center">
                <a href={"https://solscan.io/tx/"+s} target="_blank">{s}</a>
              </div>
            </div>
          </div>
        )}
      </FieldArrayIterables>
      </div>
    </div>

  </FormResource>
);

export default FormTrade;
